import React from 'react';
import { useAppContext } from '../../../Services/AppContext';
import useRootWorkplace from '../../Manager/Hooks/useRootWorkplace';
import ORSMWrapper from './ORSMWrapper';
import Loading from '../../../Components/Loading';

const ORSMRootWrapper: React.FC = () => {
	const { workplaceId, userData } = useAppContext();
	const { rootWorkplaceId, rootWorkplaceDataIsLoading } = useRootWorkplace(
		workplaceId,
		userData.id,
	);

	if (rootWorkplaceDataIsLoading || !rootWorkplaceId) {
		return <Loading />;
	}

	return <ORSMWrapper rootWorkplaceId={rootWorkplaceId} />;
};

export default ORSMRootWrapper;
